import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { AccountSettingsService } from '../account-setting.service';
import {
  onEnterBackSpace,
  transformPhone,
} from 'src/app/shared/utils/utility.service';
import { CONSTANTS as CONST } from 'src/app/shared/constants/constants';
import { config } from 'src/config/config';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { PhoneNumberFormatPipe } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.pipe';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-account-phone-change',
  templateUrl: './account-phone-change.component.html',
  styleUrls: ['./account-phone-change.component.scss'],
})
export class AccountPhoneChangeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() SuccessMessage!: string;
  @Input() email!: string;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() SuccessMessageChange = new EventEmitter<string>();
  @ViewChild('phone') phoneInput: any;
  readonly LANG_CONST = LANG_CONST;
  readonly CONST = CONST;
  changePhoneForm!: FormGroup;
  step: number = 1;
  maxLength = 14;
  regionValue: string = CONST.PHONE_NUMBER_REGION;
  newPhoneNumber: string = '';
  @Input() formGroupName!: string;
  codeType: string = 'update';
  medium: string = 'phone';
  existingPhone: string = '';
  existingCode: string = '';
  phone: any;
  get formInstance() {
    return this.changePhoneForm?.controls;
  }

  constructor(
    private fb: FormBuilder,
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    private phoneNumberFormat: PhoneNumberFormatPipe,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.changePhoneForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.existingCode = this.formInstance?.region.value;
    this.existingPhone = this.formInstance?.phone.value;
    this.phone = this.existingCode + this.existingPhone;
    this.setPhoneNumber(this.phone);
  }

  setPhoneNumber(number: any): void {
    this.helperService.validatePhoneFormat(number).subscribe(
      ({
        phoneNumber,
        region,
        code,
      }: {
        phoneNumber: string;
        region: string;
        code: string;
      }) => {
        this.formInstance.phone.setValue(
          this.phoneNumberFormat.transform(phoneNumber, code)
        );
      },
      (err: string) => {
        if (window.__dev__) console.log('validatePhoneFormat', err);
        this.notificationService?.showError(err);
        this.formInstance?.phone?.setValue('');
      }
    );
  }
  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.changePhoneForm?.enable();
    this.step = 1;
    this.changePhoneForm.patchValue({
      region: this.existingCode,
      phone: this.existingPhone,
    });
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description allow user to back to phone number form
   * @returns void
   */
  navigatePhoneForm(): void {
    this.step = 1;
    this.changePhoneForm?.enable();
  }
  /**
   * @description #onSubmit function trigger on continue button, disable the form for valid entered number
   *              and change the step to 2.
   * @returns void
   */
  onSubmit() {
    this.newPhoneNumber = `${this.formInstance?.region?.value}${this.formInstance?.phone?.value}`;
    this.step = 2;
  }
  /**
   * @description #onInputBackSpace function trigger on phone input field and check if entered input is backspace and remove last character
   * @returns void
   */

  onInputBackSpace(ev: any): void {
    onEnterBackSpace(ev, this.phoneInput);
  }
  onRegionSelected(region: any) {
    this.maxLength = this.helperService.phoneNumberLength(region);
  }
  /**
   * @description #sendSuccessMessage function trigger from otpverification component and change the step
   *              to final step of Phone Updated.
   * @returns void
   */
  sendSuccessMessage() {
    this.SuccessMessageChange.emit(
      (this.SuccessMessage = this.translate.instant('PHONE_UPDATED'))
    );
    this.stepperChange.emit((this.stepper = 5));
    this.notificationService.showSuccess(
      this.translate.instant('PHONE_NUMBER_HAS_BEEN_UPDATED_SUCCESSFULLY')
    );
  }

  /**
   * @description #enablePhone function trigger from otpverification component and change the state of form to
   *              enable/disdable
   * @param { string } field
   * @returns void
   */
  enablePhone(field: boolean) {
    if (field) {
      this.changePhoneForm?.enable();
    } else this.changePhoneForm?.disable();
  }
}
